// A request cancelled through its signal is not a failure to report: callers rethrow it
// before any toast or fallback value so React Query and `useLatestRequestSignal` see the cancel.
export default function rethrowIfAborted(error: unknown, signal?: AbortSignal) {
  if (signal?.aborted) {
    throw error;
  }
}
